import Axios from "axios";

export const SelectNomedepense = ( a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=dp&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "NOMEdp_SELECT",
        payload: response.data,
      });
    });
  };
};
